/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { v4 as uuidv4 } from 'uuid';
import { DeviceModel } from '../device/DeviceModel';

export class UniqueIdentifier {
    private static mRequestIdCounter: number = 0;

    private static networkCallId: number = 0;

    private static guidePreviewNetworkCallId: number = 0;

    private static sessionNetworkCallId: number = 0;

    private static sessionStopNetworkCallId: number = 0;

    private static actionDetailsNetworkCallId: number = 0;

    private static actionsNetworkCallId: number = 0;

    private static sessionId: string = '';

    /**
     *
     * @returns {string} originRequestId
     * format - <timestamp>-<processId>-<deviceId>-<counter>
     */
    static generateOriginRequestId = (): string => {
        const timestamp = new Date().getTime();
        const processId = 'p1234';
        const caDeviceId = DeviceModel.getCaDeviceId();
        UniqueIdentifier.mRequestIdCounter += 1;

        return `${timestamp}-${processId}-${caDeviceId}-${UniqueIdentifier.mRequestIdCounter}`;
    };

    /**
     *
     * @returns {string} x-amxn-requestId
     * format - <process id/ip address>-<service specific>-<counter>-<unix timestamp>
     */
    static generateXAmznRequestId = (): string => {
        let processId = '';
        if (DeviceModel.getTVProperties().getIpAddress() !== 'Unknown') {
            processId = DeviceModel.getTVProperties().getIpAddress();
        } else if (DeviceModel.getTVProperties().getHsn() !== 'Unknown') {
            processId = DeviceModel.getTVProperties().getHsn();
        } else if (DeviceModel.getTVProperties().getMacAddress().length !== 0) {
            processId = DeviceModel.getTVProperties().getMacAddress();
        } else {
            processId = 'p1234';
        }
        UniqueIdentifier.mRequestIdCounter += 1;
        const timestamp = new Date().getTime();

        return `${processId}-${UniqueIdentifier.mRequestIdCounter}-${timestamp}`;
    };

    static getNetworkCallId() {
        return this.networkCallId;
    }

    static getNextNetworkCallId() {
        this.networkCallId += 1;
        return this.networkCallId;
    }

    static getGuidePreviewNetworkCallId() {
        return this.guidePreviewNetworkCallId;
    }

    static getNextGuidePreviewNetworkCallId() {
        this.guidePreviewNetworkCallId += 1;
        return this.guidePreviewNetworkCallId;
    }

    static getActionsNetworkCallId() {
        return this.actionsNetworkCallId;
    }

    static getNextActionsNetworkCallId() {
        this.actionsNetworkCallId += 1;
        return this.actionsNetworkCallId;
    }

    static getSessionNetworkCallId() {
        return this.sessionNetworkCallId;
    }

    static getNextSessionNetworkCallId() {
        this.sessionNetworkCallId += 1;
        return this.sessionNetworkCallId;
    }

    static getSessionStopNetworkCallId() {
        return this.sessionStopNetworkCallId;
    }

    static getNextSessionStopNetworkCallId() {
        this.sessionStopNetworkCallId += 1;
        return this.sessionStopNetworkCallId;
    }

    static getOttActionDetailsNetworkCallId() {
        return this.actionDetailsNetworkCallId;
    }

    static getNextOttActionDetailsNetworkCallId() {
        this.actionDetailsNetworkCallId += 1;
        return this.actionDetailsNetworkCallId;
    }

    static uuid4(): string {
        return uuidv4();
    }
}
